import { create } from "zustand";

const isLoginAccountStore = create((set) => ({
  isLoginAccount: false,
  setIsLoginAccount: (newValue) =>
    set((state) => ({
      isLoginAccount: newValue
    }))
}));

export default isLoginAccountStore;
